import type { RefUser } from "../../types/Users";

function ProfilDisplay({inscription}:{inscription:RefUser}){
   
    return (

        <span>{inscription.nom??inscription.identifiant} (#{inscription.id})</span>
        
    )
}
export default ProfilDisplay;